import { useSelector } from "react-redux";
import { selectUserData } from "../../../features/userSlice";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import LeadsManagementMobile from "../../../components/BizDevelopment/LeadsManagement/Mobile/LeadsManagementMobile";
import {
  LEADS_MANAGEMENT_SITE_NAME,
  userHasWebsiteAccess,
} from "../../../components/BizDevelopment/LeadsManagement/constants";
import { useWebsiteSharedUid } from "../../../customHooks/useWebsiteSharedUid";

export default function LeadsManagementMobileScreen() {
  const userData = useSelector(selectUserData);
  const websiteSharedUid = useWebsiteSharedUid(LEADS_MANAGEMENT_SITE_NAME);
  const hasSiteAccess = userHasWebsiteAccess(userData, LEADS_MANAGEMENT_SITE_NAME);
  const hasViewPermission = CheckPermissions(
    userData?.data?.products?.partners,
    "lead_managment",
    "view_lead_managment",
  );

  return hasSiteAccess && hasViewPermission && websiteSharedUid ? (
    <LeadsManagementMobile websiteSharedUid={websiteSharedUid} />
  ) : (
    <Page404 />
  );
}
